// extracted by mini-css-extract-plugin
export var actionIcon = "_sq-0";